import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DependencyTrackComponent } from "./dependency-track.component";
import { PoFieldModule, PoModule, PoSearchModule } from "@po-ui/ng-components";
import { MarkdownParserPipe } from "./pipes/markdown-parser/markdown-parser.pipe";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DependencyTrackVulnerabilitiesComponent } from "./components/dependency-track-vulnerabilities/dependency-track-vulnerabilities.component";
import { DependencyTrackVulnerabilitiesMetricsComponent } from "./components/dependency-track-vulnerabilities-metrics/dependency-track-vulnerabilities-metrics.component";
import { DependencyTrackVulnerabilitiesTableComponent } from "./components/dependency-track-vulnerabilities-table/dependency-track-vulnerabilities-table.component";
import { DependencyTrackVulnerabilitiesTableDetailComponent } from "./components/dependency-track-vulnerabilities-table-detail/dependency-track-vulnerabilities-table-detail.component";
import { DependencyTrackProjectComponent } from "./components/dependency-track-project/dependency-track-project.component";
import { DependencyTrackVulnerabilitiesChartsComponent } from "./components/dependency-track-vulnerabilities-charts/dependency-track-vulnerabilities-charts.component";
import { DependencyTrackComponentsComponent } from "./components/dependency-track-components/dependency-track-components.component";
import { VulnerabilitiesDetailPipe } from "./pipes/vulnerabilities-detail/vulnerabilities-detail.pipe";

@NgModule({
  declarations: [
    DependencyTrackComponent,
    DependencyTrackVulnerabilitiesComponent,
    MarkdownParserPipe,
    DependencyTrackVulnerabilitiesMetricsComponent,
    DependencyTrackVulnerabilitiesTableComponent,
    DependencyTrackVulnerabilitiesTableDetailComponent,
    DependencyTrackProjectComponent,
    DependencyTrackVulnerabilitiesChartsComponent,
    DependencyTrackComponentsComponent,
    VulnerabilitiesDetailPipe,
  ],
  imports: [
    CommonModule,
    PoModule,
    FormsModule,
    PoFieldModule,
    ReactiveFormsModule,
    PoSearchModule,
  ],
  providers: [],
})
export class DependencyTrackModule {}
